<!-- TODO: This will be removed after implementing form builder -->
<div class="legacy-persona-wizard-content tw-flex tw-flex-col tw-flex-1 tw-min-h-0 tw-pb-4" [nbSpinner]="processing">
  @if (event && !processing) {
    <ngx-personas-edit
      [personaId]="personaId"
      [event]="event"
      [personas]="personas"
      [workspaceSlug]="workspaceSlug"
      [embeddedInV2Wizard]="true"
      (personasChange)="onPersonasChange(shareableLinks, $event)"
    />
  }
</div>

<ng-template #shareableLinks>
  <nb-card class="tw-max-w-full" style="width: 1090px">
    <nb-card-body>
      <ngx-personas-share
        [event]="event"
        [personas]="sharePersonas"
        [dialogMode]="true"
        (onClose)="closeShareDialog($event)"
      ></ngx-personas-share>
    </nb-card-body>
  </nb-card>
</ng-template>
